import { useTypedParams } from '@sorare/routing';

import { RewardsFixtureLeagueQualityRarityPage } from 'pages/rewards/RewardsFixtureLeagueQualityRarityPage';

import type { PageParams } from './__generated__/routeParams';

const RewardsPage = () => {
  const { league, quality, rarity } = useTypedParams<PageParams>();
  return (
    <RewardsFixtureLeagueQualityRarityPage
      league={league}
      quality={quality}
      rarity={rarity}
    />
  );
};

export default RewardsPage;
